import {
  actionGroups,
  entryPoints,
  eventActions,
  eventCategories,
  eventContents,
  eventLabels,
  events,
  productNames,
} from './constants'
import { sendInteractionGtm, sendPageviewGtm, setEntryPoint, toCd1 } from './helpers'
import { sendGtmEvent } from './sendGtmEvent'
import { HomeTab } from './types'

// Показ главной страницы
export const homePageShowGtm = () =>
  sendPageviewGtm({
    eventLabel: eventLabels.glavnaya,
  })

// Клик на переключение разделов
export const homeTabClickGtm = (tab: HomeTab) =>
  sendInteractionGtm({
    eventAction: eventActions.elementClick,
    eventLabel: tab,
    eventContent: eventContents.perekluchenieRazdela,
  })

// Клик на Поиск
export const homeSearchClickGtm = () =>
  sendInteractionGtm({
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.poisk,
  })

// Клик на сервис из предложенных вариантов поиска
export const homeSearchHitClickGtm = (productName: string) => {
  setEntryPoint(entryPoints.poisk)

  sendInteractionGtm({
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.vydachaPoiska,
    CD1: { serviceName: toCd1(productName) },
  })
}

// Клик на кнопку Войти
export const homeLoginClickGtm = () =>
  sendGtmEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.avtorizaciya,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.voiti,
    productName: productNames.igrovayaStranica,
    actionGroup: actionGroups.interactions,
  })

// Клик на сервис в разделе «Популярное»
export const homePopularClickGtm = (productName: string) => {
  setEntryPoint(entryPoints.populyarnoe)

  sendInteractionGtm({
    eventAction: eventActions.cardClick,
    eventLabel: eventLabels.populyarnoe,
    CD1: { serviceName: toCd1(productName) },
  })
}

// Клик на сервис в разделе «Донаты»
export const homeGamesClickGtm = (productName: string) =>
  sendInteractionGtm({
    eventAction: eventActions.cardClick,
    eventLabel: eventLabels.igry,
    CD1: { serviceName: toCd1(productName) },
  })

// Клик на сервис в разделе «Игровые ключи»
export const homeKeysClickGtm = (productName: string) =>
  sendInteractionGtm({
    eventAction: eventActions.cardClick,
    eventLabel: eventLabels.igrovyeKlyuchi,
    CD1: { serviceName: toCd1(productName) },
  })

// Клик на сервис в разделе «Сервисы»
export const homeServicesClickGtm = (productName: string) => {
  setEntryPoint(entryPoints.servisy)

  sendInteractionGtm({
    eventAction: eventActions.cardClick,
    eventLabel: eventLabels.servicy,
    CD1: { serviceName: toCd1(productName) },
  })
}

// Клик на Новости
export const homeNewsClickGtm = (newsName: string) =>
  sendInteractionGtm({
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.novosti,
    CD1: { newsName: toCd1(newsName) },
  })

// Ошибка «Сервис временно недоступен»
export const homeErrorShowGtm = (errorDescription: string) =>
  sendPageviewGtm({
    eventAction: eventActions.errorShow,
    eventLabel: eventLabels.oshibka,
    CD1: { errorName: toCd1(errorDescription) },
  })

// Ошибка 404
export const homeNotFoundShowGtm = () =>
  sendGtmEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovayaStranica,
    eventAction: eventActions.errorShow,
    eventLabel: eventLabels.oshibka404,
    actionGroup: actionGroups.nonInteractions,
  })
